import React from 'react';

const markdownComponents = {
    table: ({ node, ...props }) => (
        <div className='my-4 overflow-x-auto'>
            <table
                className='min-w-full divide-y divide-backgrounds-border border border-backgrounds-border'
                {...props}
            />
        </div>
    ),
    thead: ({ node, ...props }) => (
        <thead className='bg-backgrounds-primary100' {...props} />
    ),
    tbody: ({ node, ...props }) => (
        <tbody
            className='divide-y divide-backgrounds-border bg-backgrounds-white'
            {...props}
        />
    ),
    tr: ({ node, ...props }) => (
        <tr className='hover:bg-backgrounds-selected100' {...props} />
    ),
    th: ({ node, ...props }) => (
        <th
            className='px-6 py-3 text-left text-sm font-semibold text-texts-secondary300'
            {...props}
        />
    ),
    td: ({ node, ...props }) => (
        <td
            className='px-6 py-4 text-sm text-texts-secondary300 whitespace-nowrap'
            {...props}
        />
    ),
    h1: ({ node, ...props }) => (
        <h1
            className='text-2xl font-bold my-4 text-texts-secondary300'
            {...props}
        />
    ),
    h2: ({ node, ...props }) => (
        <h2
            className='text-xl font-bold my-3 text-texts-secondary300'
            {...props}
        />
    ),
    h3: ({ node, ...props }) => (
        <h3
            className='text-lg font-bold my-2 text-texts-secondary300'
            {...props}
        />
    ),
    p: ({ node, ...props }) => (
        <p className='my-2 text-texts-secondary300' {...props} />
    ),
    ul: ({ node, ...props }) => (
        <ul
            className='list-disc ml-4 my-2 text-texts-secondary300'
            {...props}
        />
    ),
    ol: ({ node, ...props }) => (
        <ol
            className='list-decimal ml-4 my-2 text-texts-secondary300'
            {...props}
        />
    ),
    code: ({ node, inline, ...props }) => (
        <code
            className='bg-backgrounds-primary100 text-texts-tertiary400 rounded px-1 py-0.5 font-mono'
            {...props}
        />
    ),
    pre: ({ node, ...props }) => (
        <pre
            className='bg-backgrounds-primary100 rounded p-4 overflow-x-auto my-2 text-texts-secondary300 font-mono'
            {...props}
        />
    ),
    blockquote: ({ node, ...props }) => (
        <blockquote
            className='border-l-4 border-backgrounds-border pl-4 my-2 italic text-texts-secondary300'
            {...props}
        />
    ),
    a: ({ node, ...props }) => (
        <a
            className='text-texts-tertiary hover:text-texts-tertiary300 hover:underline'
            target='_blank'
            rel='noopener noreferrer'
            {...props}
        />
    ),
};

export default markdownComponents;
